// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reset-password .input-eva-border-bottom{padding-left:0;max-width:440px}.reset-password .input-eva-border-bottom::-webkit-input-placeholder{padding-right:0}.reset-password .input-eva-border-bottom::-moz-placeholder{padding-right:0}.reset-password .input-eva-border-bottom:-ms-input-placeholder{padding-right:0}.reset-password .input-eva-border-bottom::-ms-input-placeholder{padding-right:0}.reset-password .input-eva-border-bottom::placeholder{padding-right:0}\n", ""]);
// Exports
module.exports = exports;
